import CompanyEditForm from '@rd-web-markets/shared/dist/company/CompanyEditForm';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Tab, Card } from 'react-bootstrap';
import BusinessUnitPage from '@rd-web-markets/shared/dist/company/BusinessUnits/BusinessUnitPage';
import CompetentProfessionalTab from './CompetentProfessional/CompetentProfessionalTab';
export function CompanyEditPageContent(_ref) {
  let {
    claimTemplates,
    company,
    setCompany,
    handleSubmit,
    loading,
    handleToaster,
    setLoading,
    questionnaires,
    CompanyMarketRelatedFields
  } = _ref;
  const {
    t
  } = useTranslation();
  const [key, setKey] = useState('edit_company');
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Header, {
    className: "bg-primary bg-gradient text-white"
  }, t('edit_company')), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Tabs, {
    activeKey: key,
    onSelect: k => setKey(k),
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "edit_company",
    title: "Company Details"
  }, /*#__PURE__*/React.createElement(CompanyEditForm, {
    claimTemplates: claimTemplates,
    selectedCompany: company,
    handleSubmit: handleSubmit,
    loading: loading,
    handleToaster: handleToaster,
    setLoading: setLoading,
    questionnaires: questionnaires,
    CompanyMarketRelatedFields: CompanyMarketRelatedFields
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "business_units",
    title: "Business Units"
  }, /*#__PURE__*/React.createElement(BusinessUnitPage, {
    handleToaster: handleToaster,
    company: company,
    loading: loading,
    setLoading: setLoading,
    setCompany: setCompany
  })), /*#__PURE__*/React.createElement(Tab, {
    eventKey: "competent_professional",
    title: "Competent Professional"
  }, /*#__PURE__*/React.createElement(CompetentProfessionalTab, {
    eventKey: key
  })))));
}